import { Injectable } from '@angular/core';
import { BaseService } from '../../shared/services/base.service';
import { ValidationService } from '../../shared/services/validation.service';
import { BehaviorSubject } from "rxjs/BehaviorSubject"
import { UserUrl } from '../../shared/urls/user.url';
import { RequestAppointmentUrl } from '../../shared/urls/request-appointment.url';
import { PatientUrl } from '../../shared/urls/patient.url';

@Injectable()
export class RequestAppointmentService {
  constructor(public baseService: BaseService) {

  }
  getInit() {
    const url = RequestAppointmentUrl.GET_BOOKING_INIT;
    return this.baseService.getData(url);
  }

  getAllCentre() {
    const url = RequestAppointmentUrl.GET_ALL_CENTRE;
    return this.baseService.getAll(url);
  }
  getTravelDestination() {
    const url = UserUrl.GET_USER_COUNTRY;
    return this.baseService.getData(url);
  }

  getUserCountryList() {
    return this.baseService.getData(UserUrl.GET_USER_COUNTRY);
  }
  addBookingCache(param) {
    const url = RequestAppointmentUrl.ADD_BOOKING_CACHE;
    return this.baseService.postData(url, param);
  }
  getBookingCache(centreId) {
    const url = RequestAppointmentUrl.GET_BOOKING_CACHE.replace('{centreId}', centreId);
    return this.baseService.getData(url);
  }
  deleteBookingCache() {
    const url = RequestAppointmentUrl.DELETE_BOOKING_CACHE;
        return this.baseService.delete(url);
  }
  getPatientDetail(id) {
    const url = PatientUrl.PATIENT_GET;
    return this.baseService.getById(url, id);
  }
  validateDateRange(fromDateControl, toDateControl, isFromDateActive) {
    if (ValidationService.isValidDate(fromDateControl) || ValidationService.isValidDate(toDateControl)) {
      return;
    }
    // validate fromDate < toDate
    if (ValidationService.compareDate(fromDateControl, toDateControl) === 1) {
      if (isFromDateActive) {
        fromDateControl.setErrors({ 'invalidDateBooking': true });
      } else {
        toDateControl.setErrors({ 'invalidDateBooking': true });
      }
    } else {
      fromDateControl.setErrors(null);
      toDateControl.setErrors(null);
    }
  }
}
export const bookingType = [
  {
    id: 0,
    name: 'Individual'
  },
  {
    id: 1,
    name: 'Group'
  },
  {
    id: 2,
    name: 'Flue Vaccine'
  },
];

export const reasonForTrip = [
  {
    id: 1,
    name: 'Business'
  },
  {
    id: 2,
    name: 'Holiday'
  },
  {
    id: 3,
    name: 'VFR'
  },
  {
    id: 4,
    name: 'Assignment'
  },
  {
    id: 5,
    name: 'Honeymoon'
  },
  {
    id: 6,
    name: 'Other'
  }
];

export const typeAccommadation = [
  {
    id: 1,
    name: 'Trekking'
  },
  {
    id: 2,
    name: 'Cruise'
  },
  {
    id: 3,
    name: 'Residential/Hostel'
  },
  {
    id: 4,
    name: 'Hotel/Urban'
  },
  {
    id: 5,
    name: 'Other'
  }
];

export const paymentTerm = [
  {
    id: 1,
    term: 'Group 15 day credit'
  },
  {
    id: 2,
    term: 'Group members paying individually'
  }
];

export const duration = [
  {
    id: 1,
    name: '5 Minutes'
  },
  {
    id: 2,
    name: '10 Minutes'
  },
  {
    id: 3,
    name: '15 Minutes'
  },
  {
    id: 4,
    name: '20 Minutes'
  }
];

const partyType = [
  {
    id: 0,
    name: '5 Minutes'
  },
  {
    id: 1,
    name: '10 Minutes'
  },
  {
    id: 2,
    name: '15 Minutes'
  },
  {
    id: 4,
    name: '20 Minutes'
  }
];



// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/pages/request-appointment/request-appointment.service.ts